import { useQuery } from 'data-fetching-client';
import { GET_LEGACY_INTEGRATION_EVENTS } from 'flow-doctor-lib/queries/IntegratorQueries';
const useLegacyIntegrationEvent = ({
  portalId,
  eventId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_LEGACY_INTEGRATION_EVENTS, {
    variables: {
      portalId
    }
  });
  const dataToReturn = data ? data.legacyIntegrationEvents.find(event => event.id === eventId) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useLegacyIntegrationEvent;